var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.6 104H103.5V444.1H443.6V104Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M919.7 104H579.6V444.1H919.7V104Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 580.1H104.3V920.2H444.4V580.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M920.6 580.1H580.5V920.2H920.6V580.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg222);
export default __webpack_public_path__ + "static/media/222.6823ccf732fcf4c9a9818cff276c03c9.svg";
export { ForwardRef as ReactComponent };